module.exports = true;


//////////////////
// WEBPACK FOOTER
// C:/Users/ondrej.siroky/Documents/frontend/~/core-js/library/modules/_library.js
// module id = 27
// module chunks = 0 1 2 3